export default __webpack_public_path__ + "static/media/Sanitarios Portátiles3.2c753135.png";